<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <label>{{ $t('common_words.evaluation') }}</label>
            <br />
            <el-select
              clearable
              @change="setEvaluation"
              filterable
              class="select-primary custom-width-select shadow-sm quality-form"
              size="large"
              v-model="qualityForm.qualityHeaderId"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in qualities"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <label>{{ $t('common_words.farm') }}</label>
            <br />
            <el-select
              clearable
              @change="setFarm"
              :disabled="disabledFarm"
              filterable
              class="select-primary custom-width-select shadow-sm farm-form"
              size="large"
              v-model="qualityForm.farm_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div v-if="isLote" class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <label>{{ $t('common_words.allotment') }}</label>
            <br />
            <el-select
              clearable
              @change="hideView"
              :disabled="disabledLote"
              filterable
              class="select-primary custom-width-select shadow-sm lote-form"
              size="large"
              v-model="qualityForm.lot_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in lots"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + '-' + option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <br class="media-none" />
            <label>{{ $t('common_words.date') }}</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              @change="hideView"
              :picker-options="pickerOptions"
              class="shadow-sm date-form"
              v-model="qualityForm.date"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="`${$t('common_words.select')}...`"
            >
            </el-date-picker>
          </div>
          <div class="col-6 col-md-4 col-lg-4 col-xl-3">
            <label class="label-primary" style="color: transparent">{{
              $t('common_words.preload')
            }}</label
            ><br />
            <button class="btn btn-info btn-fg" @click.prevent="preload">
              <i class="fa fa-table"></i>{{ $t('common_words.preload') }}
            </button>
          </div>
        </div>
        <br />
      </card>
      <card class="custom-shadow-card-header" v-if="showPreload">
        <form>
          <div class="row">
            <div class="col-12">
              <div class="text-center">
                <div class="form-group has-label">
                  <el-upload
                    drag
                    ref="qualityUpload"
                    :action="getAxiosURL() + '/auth/quality/quality/preload'"
                    :data="getFileRequestData"
                    :headers="headerInfo"
                    :limit="1"
                    :on-exceed="handleExceed"
                    :on-success="handleSuccess"
                    :before-upload="beforeUpload"
                    :file-list="fileList"
                    :auto-upload="false"
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                      {{ $t('common_words.finished_format') }}
                      <em> {{ $t('common_words.click_to_load') }}</em>
                    </div>
                    <div slot="tip" class="el-upload__tip">
                      {{ $t('common_words.xlsx_notice') }}
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="text-center" v-if="isCreate()">
                <button
                  style="margin-right: 10px"
                  class="btn btn-info btn-fg"
                  @click.prevent="downloadFormat"
                >
                  <i class="fa fa-file-excel-o"></i
                  >{{ $t('common_words.download_file') }}
                </button>
                <button
                  class="btn btn-info btn-fg"
                  @click.prevent="submitUpload"
                >
                  <i class="fa fa-plus"></i
                  >{{ $t('common_words.validate_file') }}
                </button>
              </div>
            </div>
          </div>
        </form>
        <br />
      </card>
      <capture-confirm
        v-if="showTable"
        module="quality"
        :tasks="qualityTasks"
        :photoColumn="photoColumn"
        :farmId="qualityForm.farm_id"
        :observationBySubcategory="false"
        @save="storeQualityCapture"
        @delete="clear"
      ></capture-confirm>
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import axios from 'axios';
import CaptureConfirm from 'src/components/Forms/CaptureConfirm.vue';
import i18n from 'src/i18n';
import mixinLocation from 'src/util/mixinLocation';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    CaptureConfirm,
  },

  data() {
    return {
      qualityForm: {
        qualityHeaderId: null,
        farm_id: null,
        lot_id: null,
        date: moment().format('YYYY-MM-DD hh:mm:ss'),
        qualityTasks: [],
        user_id: this.$store.state.auth.user.id,
      },
      showTable: false,
      showPreload: false,
      farms: null,
      qualities: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      headerInfo: {
        Authorization: 'Bearer ' + this.$store.state.auth.token,
      },
      fileList: [],
      lots: [],
      qualityTasks: [],
      isLote: false,
      photoColumn: false,
      disabledFarm: true,
      disabledLote: true,
    };
  },

  watch: {
    '$i18n.locale': 'forceRerender',
  },

  computed: {
    getFileRequestData() {
      let data = {
        qualityHeaderId: this.qualityForm.qualityHeaderId,
        farm_id: this.qualityForm.farm_id,
        date: moment(this.qualityForm.date).format('YYYY-MM-DD hh:mm:ss'),
      };
      if (this.qualityForm.lot_id) {
        data.lot_id = this.qualityForm.lot_id;
      }
      return data;
    },
  },

  mixins: [
    mixinMasters,
    MixinPermissions,
    MixinNotification,
    MixinExport,
    MixinMenu,
    mixinLocation,
  ],

  methods: {
    hideView() {
      this.showTable = false;
      this.showPreload = false;
    },

    cleanView() {
      this.showTable = false;
      this.showPreload = false;
      this.qualityForm.qualityTasks = [];
    },

    validateFilter() {
      if (this.qualityForm.qualityHeaderId == null) {
        this.highlightItem('quality-form');
        return false;
      } else if (this.qualityForm.farm_id == null) {
        this.highlightItem('farm-form');
        return false;
      } else if (this.qualityForm.date == null) {
        this.highlightItem('date-form');
        return false;
      } else if (this.isLote && this.qualityForm.lot_id == null) {
        this.highlightItem('lote-form');
        return false;
      }
      return true;
    },

    preload() {
      this.cleanView();
      if (this.validateFilter()) {
        this.showTable = false;
        this.showPreload = true;
      }
    },

    async getLocation() {
      const locationData = await this.getPosition();
      return {
        lat: locationData.lat,
        lng: locationData.lng,
        alt: locationData.alt,
      };
    },

    getDateWithTime() {
      const filterDate = new Date(this.qualityForm.date);
      const thisDate = new Date();
      const requestDate = new Date(
        filterDate.getFullYear(),
        filterDate.getMonth(),
        filterDate.getDate(),
        thisDate.getHours(),
        thisDate.getMinutes(),
        thisDate.getSeconds()
      );
      return moment(requestDate).format('YYYY-MM-DD HH:mm:ss');
    },

    async storeQualityCapture(data) {
      this.showHideLoading(true);
      if (this.isCreate() || this.isUpdate()) {
        this.qualityForm.route = 'quality/inspections/store';
        this.qualityForm.qualityTasks = data.tasksForm;
        const options = { headers: { 'Content-Type': 'multipart/form-data' } };
        let formData = new FormData();
        formData.append('qualityHeaderId', this.qualityForm.qualityHeaderId);
        formData.append('farm_id', this.qualityForm.farm_id);
        if (this.qualityForm.lot_id) {
          formData.append('lot_id', this.qualityForm.lot_id);
        }
        if (data.image) {
          formData.append('image', data.image);
        }
        if (data.observations) {
          formData.append('observations', data.observations);
        }
        formData.append('date', this.getDateWithTime());
        formData.append('user_id', this.qualityForm.user_id);

        try {
          const location = await this.getLocation();
          formData.append('altitude', location.alt);
          formData.append('longitude', location.lng);
          formData.append('latitude', location.lat);
          formData.append('qualityTasks', JSON.stringify(data.tasksForm));
          data.tasksForm.forEach((item) => {
            if (item.photo) {
              formData.append(`photo_${item.id}`, item.photo);
            }
          });
          axios
            .post('auth/quality/inspections/store', formData, options)
            .then((response) => {
              if (response.status) {
                this.showHideLoading();
                this.showNotification(
                  `${response.data.message}`,
                  'success',
                  'nc-simple-add',
                  i18n.t('common_words.successful_creation')
                );
                this.softDelete();
              }
            })
            .catch((error) => this.showMessageErrors(error));
        } catch (error) {
          this.showHideLoading();
        }
      } else {
        this.showMessageAccess();
        this.showHideLoading();
      }
    },

    clear() {
      const qualityHeader = this.qualities.find(
        (quality) => quality.id === this.qualityForm.qualityHeaderId
      );
      SweetAlert.delete(
        i18n.t('common_words.evaluation_capture') + qualityHeader.name
      ).then((result) => {
        if (result.value) this.deleteAll();
      });
    },

    softDelete() {
      this.cleanView();
      this.qualityForm = {
        qualityHeaderId: this.qualityForm.qualityHeaderId,
        farm_id: this.qualityForm.farm_id,
        lot_id: this.qualityForm.lot_id,
        date: moment().format('YYYY-MM-DD hh:mm:ss'),
        user_id: this.$store.state.auth.user.id,
        qualityTasks: [],
      };
    },

    deleteAll() {
      this.cleanView();
      this.qualityForm = {
        qualityHeaderId: null,
        farm_id: null,
        lot_id: null,
        date: moment().format('YYYY-MM-DD hh:mm:ss'),
        user_id: this.$store.state.auth.user.id,
        qualityTasks: [],
      };
    },

    handleExceed(files, fileList) {
      SweetAlert.warning(
        `${i18n.t('sweet_alert.ground.selected_limit')} ${
          files.length
        } ${i18n.t('sweet_alert.ground.files')}`
      );
    },

    handleSuccess(res, file) {
      if (res.errors) {
        let html = ``;
        res.errors.forEach((error) => {
          html += `<p> ${error} </p>`;
        });
        SweetAlert.warning(html);
      } else if (res.success) {
        this.qualityTasks = res.success;
        this.photoColumn = res.photoColumn;
        this.showPreload = false;
        this.showTable = true;
      }
      this.$refs.qualityUpload.clearFiles();
    },

    beforeUpload(file) {
      const validateDocument = this.validateDocument(file.type);
      if (!validateDocument) {
        return false;
      }
      this.qualityForm.date = moment(this.qualityForm.date).format(
        'YYYY-MM-DD hh:mm:ss'
      );
    },

    validateDocument(fileType) {
      const isXLSX = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel',
        'application/wps-office.xlsx',
      ].includes(fileType);
      if (!isXLSX) {
        SweetAlert.warning(i18n.t('common_words.xlsx_format_notice'));
        return false;
      }
      return true;
    },

    submitUpload() {
      if (this.$refs.qualityUpload.uploadFiles.length > 0) {
        this.$refs.qualityUpload.submit();
      } else {
        SweetAlert.warning(i18n.t('common_words.xlsx_format_notice'));
      }
    },

    downloadFormat() {
      let self = this;
      let data = self.qualityForm;
      data.route = 'quality/quality/preformat';
      data.name_file = 'precarga_calidad.xlsx';
      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          SweetAlert.warning(i18n.t('sweet_alert.common.download_error'));
        });
    },

    getLots(farmId) {
      Axios.getMasters('lots/' + farmId)
        .then((response) => {
          this.lots = response.data.data;
          this.disabledLote = false;
        })
        .catch((error) => this.showMessageErrorsSwalAlert(error));
    },

    setEvaluation() {
      this.qualityForm.farm_id = null;
      this.qualityForm.lot_id = null;
      const selectQuality = Object.values(this.qualities).find(
        (quality) => quality.id === this.qualityForm.qualityHeaderId
      );
      this.isLote = selectQuality.catch_type == 1 ? true : false;
      this.disabledFarm = false;
      this.disabledLote = true;
      this.hideView();
    },

    setFarm() {
      this.qualityForm.lot_id = null;
      if (this.isLote) {
        this.getLots(this.qualityForm.farm_id);
      }
      this.hideView();
    },
  },

  created() {
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([
        Axios.getMasters('farms/farms/only'),
        Axios.getMasters('quality/quality/captures'),
      ])
        .then(([farmsResponse, qualityResponse]) => {
          this.farms = farmsResponse.data.data;
          this.qualities = qualityResponse.data;
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrorsSwalAlert(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('quality');
  },

  destroyed() {
    this.deselectedItemOnMenu('quality');
  },
};
</script>
<style>
.table-journals td:empty {
  visibility: hidden;
}

.table-journals td:blank {
  visibility: hidden;
}

.sticky-column {
  position: absolute;
  z-index: 100;
  background: #f8fcfe;
  box-shadow: 5px 0px 5px rgba(195, 209, 226, 0.2),
    0px -1px 0px rgba(195, 209, 226, 1);
}
</style>
<style scope>
.card .avatar {
  height: 100%;
  overflow: hidden;
  border-radius: 0% !important;
  margin-right: 0px !important;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.avatar-uploader-bad .el-upload {
  border-color: red !important;
}
.general {
  width: 400px;
  height: 141px;
  display: block;
}
.general-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 400px;
  height: 141px;
  line-height: 150px;
  text-align: center;
}
</style>
